<template lang="pug">
    collapse-component.conteudo(title='Filtrar processos')
        .linha
            .coluna-3
                text-input-component(v-model='filtro.car', label='Número de registro no CAR')
            .coluna-3
                text-input-component(v-model='filtro.nomeImovel', label='Nome do imóvel')
        .linha(style="align-items: flex-start")
            .coluna-3
                text-input-component(v-model='filtro.cpfCnpjProprietario', label='CPF/CNPJ')
            .coluna-2
                date-picker-component(v-model='filtro.dataEnvioDe', label='Data inicial de vinculação')
            .coluna-2
                date-picker-component(v-model='filtro.dataEnvioAte', label='Data final de vinculação')
            .coluna-2
                select-filter-component(
                    v-if="mostrarCondicao"
                    ref='selectCondicao'
                    :list='condicao',
                    label='nome',
                    fieldLabel='Condição',
                    :filterable='true'
                    @change='selecionarCondicao'
                )
        .linha(style="align-items: flex-start")
            .coluna-2
                text-input-component(:disabled='true', v-model='filtro.uf', label='UF')
            .coluna-2
                select-filter-component(
                    ref='selectMunicipio'
                    :list='municipios'
                    label='nome'
                    fieldLabel='Município:'
                    placeholder='Selecione'
                    :filterable='true'
                    @change='selecionarMunicipio'
                )
            .coluna-2
                select-filter-component(
                    v-if="mostrarFaseProcesso"
                    ref='selectCondicaoInscricao'
                    :list='condicaoInscricao'
                    key='id',
                    label='label'
                    fieldLabel='Fase do Processo:'
                    placeholder='Selecione'
                    :filterable='true'
                    @change='selecionarCondicaoInscricao'
                )
            .coluna-2
                select-filter-component(
                    ref='selectTecnico'
                    :list='tecnicos'
                    label='nomeRazaoSocial'
                    key='id'
                    fieldLabel='Técnico'
                    :filterable='true'
                    @change='selecionarTecnico'
                )
        .linha.justify-end
            .coluna-1
                button-component(
                    label='Limpar',
                    icon='mdi-trash-can',
                    background-color='#ddd',
                    color='#666',
                    @click.native='limpar'
                )
            .coluna-1
                button-component(label='Pesquisar', icon='mdi-magnify', @click.native='pesquisar')
    </template>

<script>
import {
  CondicaoEnum,
  CondicaoInscricaoEnum,
  ListaCondicoes,
} from "@/enums/processo.enum.js";
import { Perfil } from "@/utils/constants.utils.js";

export default {
  name: "FiltroComponent",
  props: {
    mostrarCondicao: {
      type: Boolean,
      default: true,
    },
    municipios: {
      type: Array,
      required: true,
    },
    tecnicos: {
      type: Array,
      required: false,
    },
    fasesProcesso: {
      type: Array,
      required: false,
    },
    mostrarFaseProcesso: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filtro: {
        uf: "SP",
        pagina: 1,
        quantidadePagina: 10,
        car: "",
        nomeImovel: "",
        cpfCnpjProprietario: "",
        dataEnvioDe: "",
        dataEnvioAte: "",
        condicao: "",
        tecnico: "",
        faseProcesso: "",
        municipio: "",
      },
      CondicaoEnum,
      condicao: [
        {
          id: CondicaoEnum.AGUARDANDO_ANALISE.id,
          nome: CondicaoEnum.AGUARDANDO_ANALISE.nome,
        },
        { id: CondicaoEnum.EM_ANALISE.id, nome: CondicaoEnum.EM_ANALISE.nome },
      ],
      CondicaoInscricaoEnum,
      condicaoInscricao: [],
    };
  },
  watch: {
    "$route.meta.titulo"() {
      this.filtrarcondicao();
      this.filtrarcondicaoInscricao();
    },
  },

  mounted() {
    this.filtrarcondicao();
    this.filtrarcondicaoInscricao();
  },

  methods: {
    isPageValidacaoProposta() {
      return this.$route.meta.titulo === "Validação da Proposta";
    },
    filtrarcondicao() {
      this.limpar();
      let codigoPagina = this.$route.meta.codigo;
      const usuario = this.$eu();
      if (
        usuario.perfil === Perfil.GERENTE_OPERACIONAL &&
        codigoPagina === "CONSULTAR_PROCESSOS"
      ) {
        codigoPagina = codigoPagina + "_GO";
      }
    },
    filtrarcondicaoInscricao() {
      this.condicaoInscricao = Object.values(CondicaoInscricaoEnum);
    },
    limpar() {
      this.filtro = {
        uf: "SP",
        pagina: 1,
        quantidadePagina: 10,
      };

      if (
        this.$refs.selectCondicao &&
        this.$refs.selectCondicao.itemSelecionado
      ) {
        this.$refs.selectCondicao.itemSelecionado = "";
      }

      if (
        this.$refs.selectMunicipio &&
        this.$refs.selectMunicipio.itemSelecionado
      ) {
        this.$refs.selectMunicipio.itemSelecionado = "";
      }

      if (
        this.$refs.selectTecnico &&
        this.$refs.selectTecnico.itemSelecionado
      ) {
        this.$refs.selectTecnico.itemSelecionado = "";
      }

      if (this.mostrarFaseProcesso && this.$refs.selectCondicaoInscricao) {
        this.$refs.selectCondicaoInscricao.itemSelecionado = "";
      }

      if (this.isPageValidacaoProposta()) {
        this.$refs.selectCondicao.itemSelecionado =
          CondicaoEnum.AGUARDANDO_VALIDACAO_ANALISE.nome;
      }
      this.$emit("filtro:limpar", this.filtro);
    },
    pesquisar() {
      this.$emit("filtro:pesquisar", this.filtro);
    },
    selecionarCondicao(condicao) {
      this.filtro.condicao = condicao;
    },
    selecionarTecnico(tecnico) {
      this.filtro.tecnico = tecnico;
    },
    selecionarFaseProcesso(faseProcesso) {
      this.filtro.faseProcesso = faseProcesso;
    },
    selecionarCondicaoInscricao(condicaoInscricao) {
      this.filtro.condicaoInscricao = condicaoInscricao;
    },
    selecionarMunicipio(municipio) {
      this.filtro.municipio = municipio;
    },
  },
};
</script>
